import { IntentionalAny } from './common';

/**
 * Please note these are duplicated from the Auth Service backend folder.
 * If a new error code is added there, then it must be added here as well.
 *
 * @remarks
 *
 * If we were to import all types form the backend, backend-only packages
 * would be resolved and packaged into the FE application. We don't want that.
 */

export enum ErrorTypes {
  UserAlreadyExists = 'UNKNOWN_ERROR',
  MissingUserSession = 'MISSING_USER_SESSION',
  UserNotFound = 'USER_NOT_FOUND',
  MissingPasswordResetHash = 'MISSING_PASSWORD_RESET_HASH',
  PasswordsDoNotMatch = 'PASSWORDS_DO_NOT_MATCH',
  PasswordTooWeak = 'PASSWORD_TOO_WEAK',
  HashInvalidOrExpired = 'HASH_INVALID_OR_EXPIRED',
  UserVerifyEmailMissingHash = 'USER_VERIFY_EMAIL_MISSING_HASH',
  UserVerifyEmailFailed = 'USER_VERIFY_EMAIL_FAILED',
  RefreshTokenInvalid = 'REFRESH_TOKEN_INVALID',
  InvalidGrantType = 'INVALID_GRANT_TYPE',
  InvalidClientId = 'INVALID_CLIENT_ID',
  MissingClientId = 'MISSING_CLIENT_ID',
  MissingRequiredCookies = 'MISSING_REQUIRED_COOKIES',
  RedirectUriMisMatch = 'REDIRECT_URI_MISMATCH',
  AuthorizationCodeFailedVerification = 'AUTHORIZATION_CODE_FAILED_VERIFICATION',
  MissingOrUnsupportedCodeChallenge = 'MISSING_OR_UNSUPPORTED_CODE_CHALLENGE',
  PKCEInvalid = 'PKCE_INVALID',
  AuthorizationTokenNotFound = 'AUTHORIZATION_TOKEN_NOT_FOUND',
  AuthorizationHeaderInvalid = 'AUTHORIZATION_HEADER_INVALID',
  InvalidTokenType = 'INVALID_TOKEN_TYPE',
  InvalidBody = 'INVALID_BODY',
  UserAlreadyExistsAuthed = 'USER_ALREADY_EXISTS',
  UnknownError = 'UNKNOWN_SYSTEM_ERROR',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  InvalidToken = 'INVALID_TOKEN',
  JwtMalformed = 'JWT_MALFORMED',
  InvalidSignature = 'INVALID_SIGNATURE',
  JwtExpired = 'JWT_EXPIRED',
  Unauthorized = 'UNAUTHORIZED',
  UserAccountDeleted = 'USER_ACCOUNT_DELETED',
  /**
   * Frontend only error codes
   */
  ServerError = 'SERVER_ERROR',
  InvalidEmailAddress = 'INVALID_EMAIL_ADDRESS',
  InvalidCaptcha = 'INVALID_CAPTCHA',
}

export enum ResponseTypes {
  UserCreated = 'USER_CREATED',
  UserUpdated = 'USER_UPDATED',
  UserPasswordResetRequest = 'USER_PASSWORD_RESET_REQUEST',
  UserPasswordReset = 'USER_PASSWORD_RESET',
  UserVerifyEmailConfirmation = 'USER_VERIFY_EMAIL_CONFIRMATION',
  UserGet = 'USER_GET',
  ApplicationCreated = 'APPLICATION_CREATED',
  ApplicationGet = 'APPLICATION_GET',
  ApplicationAlreadyExists = 'APPLICATION_ALREADY_EXISTS',
  RedirectUrlCreated = 'REDIRECT_URL_CREATED',
  RedirectUrlDeleted = 'REDIRECT_URL_DELETED',
  MagicTokenCreated = 'MAGIC_TOKEN_CREATED',
  MagicTokenRetrieved = 'MAGIC_TOKEN_RETRIEVED',
  UserDeleted = 'USER_DELETED',
}

export enum ErrorCodes {
  _100 = 100,
  _101 = 101,
  _102 = 102,
  _103 = 103,
  _104 = 104,
  _105 = 105,
  _106 = 106,
  _107 = 107,
  _108 = 108,
  _109 = 109,
  _110 = 110,
  _111 = 111,
  _112 = 112,
  _113 = 113,
  _114 = 114,
  _115 = 115,
  _116 = 116,
  _117 = 117,
  _118 = 118,
  _119 = 119,
  _120 = 120,
  _121 = 121,
  _122 = 122,
  _123 = 123,
  _124 = 124,
  _180 = 180,
  _181 = 181,
  _182 = 182,
  _183 = 183,
  _184 = 184,
}
export enum ResponseCodes {
  _200 = 200,
  _201 = 201,
  _202 = 202,
  _203 = 203,
  _204 = 204,
  _205 = 205,
  _206 = 206,
  _207 = 207,
  _208 = 208,
  _209 = 209,
  _210 = 210,
  _211 = 211,
  _212 = 212,
  _213 = 213,
}

export type BaseResponse = {
  message: string;
  messageTs?: string;
} & (
    | {
      error: true;
      code: ErrorCodes;
      type: ErrorTypes;
    }
    | {
      error: false;
      code: ResponseCodes;
      type: ResponseTypes;
    }
  );

export type SignupResponse = BaseResponse & {
  user?: IntentionalAny;
  redirectUrl?: string;
  created?: boolean;
};

// NB: intentionally carries no reset url / hash. The reset link goes to the
// account's email address only.
export type UserResetPasswordResponse = BaseResponse;
